function debounce(fn, delay) {
  let timeoutID
  return function(...args) {
    clearTimeout(timeoutID)
    timeoutID = setTimeout(() => fn.apply(this, args), delay)
  }
}

export default function useHandleHtmlClick() {
  const router = useRouter()
  const debouncedNavigation = debounce((href) => {
    router.push(href)
  }, 300)
  return (event) => {
    if (event.target.tagName === 'A') {
      const href = event.target.getAttribute('href')

      if (href.startsWith('/')) {
        event.preventDefault()
        debouncedNavigation(href)
      }
    }
  }
}
